import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditStationsReportTable from "../components/Stations";

export default function AuditStationReport() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('Stations report Audit - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditStationsReportTable />
        </Layout>
    )
}